module.exports = __webpack_public_path__ + "img/modal-aceptar-rechazar.02b58a22.svg";